import React, { useEffect } from "react";
import SimpleBanner from "../../components/common/SimpleBanner";
import ContactInfo from "../../components/User/Conatct/ContactInfo";
import ContactForm from "../../components/User/Conatct/Contactform";
import { useLocation } from "react-router-dom";

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#contact-form") {
      setTimeout(() => {
        const section = document.getElementById("contact-form");

        if (section) {
          const yOffset = -70; 
          const y =
            section.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({
            top: y,
            behavior: "smooth",
          });
        }
      }, 100);
    }
  }, [location]);

  return (
    <div>
      <SimpleBanner title="Contact Us" subheading="Home /Contact Us" />
      <ContactInfo />
      <ContactForm />
    </div>
  );
};

export default Contact;
